import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["fr", "de", "it", "pt", "en"],
  defaultLocale: "fr",
  localePrefix: "always",
});
